import { createReducer, on } from '@ngrx/store';

import * as fromModuleModels from '../../models';
import { StorageSystemsActions } from '../actions';
import { ErrorsObject } from '../../../shared/utilities/error-utility.utility';
import { getAndHandleBackendErrors } from '../../../shared/utilities/reducer.utility';
import { UserRoleActions } from '../../../application-state/store/actions';

export interface State {
  entities: { [iri: string]: fromModuleModels.StorageSystem };
  errors: ErrorsObject;
  loading: boolean;
  loaded: boolean;
  paginationIdPrev?: number;
  paginationIdNext?: number;
}

const initialState = {
  entities: {},
  errors: {},
  loading: false,
  loaded: false
};

export const reducer = createReducer(
  initialState,
  on(
    StorageSystemsActions.CreateStorageSystem,
    StorageSystemsActions.ReadStorageSystem,
    StorageSystemsActions.ReadStorageSystems,
    StorageSystemsActions.UpdateStorageSystem,
    StorageSystemsActions.DeleteStorageSystem,
    state => {
      return {
        ...state,
        loading: true,
        loaded: false
      };
    }
  ),
  on(StorageSystemsActions.ReadStorageSystemSuccess, (state, { response }) => {
    const entities = {
      ...state.entities,
      [response['@id']]: response
    };

    return {
      ...state,
      entities,
      loading: false,
      loaded: false
    };
  }),
  on(StorageSystemsActions.ReadStorageSystemsSuccess, (state, { response }) => {
    const items = response['hydra:member'];
    const entities = items.reduce(
      (entities: { [iri: string]: fromModuleModels.StorageSystem }, item) => {
        return {
          ...entities,
          [item['@id']]: item
        };
      },
      { ...state.entities }
    );

    return {
      ...state,
      entities,
      loading: false,
      loaded: true
    };
  }),
  on(
    StorageSystemsActions.CreateStorageSystemSuccess,
    StorageSystemsActions.UpdateStorageSystemSuccess,
    (state, { response }) => {
      const entities = {
        ...state.entities,
        [response['@id']]: response
      };

      return {
        ...state,
        entities,
        loading: false,
        loaded: true
      };
    }
  ),
  on(StorageSystemsActions.DeleteStorageSystemSuccess, (state, { iri }) => {
    const { [iri]: removedItem, ...entities }: any = state.entities;

    return {
      ...state,
      entities,
      loading: false,
      loaded: true
    };
  }),
  on(
    StorageSystemsActions.CreateStorageSystemFail,
    StorageSystemsActions.ReadStorageSystemFail,
    StorageSystemsActions.ReadStorageSystemsFail,
    StorageSystemsActions.UpdateStorageSystemFail,
    StorageSystemsActions.DeleteStorageSystemFail,
    (state, { response }) => {
      return {
        ...state,
        errors: getAndHandleBackendErrors(response),
        loading: false,
        loaded: false
      };
    }
  ),
  on(UserRoleActions.UserRoleCheckFail, state => ({ ...state, loading: false }))
);
